import React from "react";
import styled from "@emotion/styled";

const ImageDiv = styled.div`
  max-width: 278px;
  margin: 0 auto;
  margin-top: 34px;

  @media (max-width: 950px) {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: center;
    align-items: center;
    grid-gap: 30px;
    max-width: initial;
  }
  @media (max-width: 465px) {
    display: grid;
    grid-template-columns: 1fr 0.75fr;
    max-width: 80%;
  }
`;

const PaypalImage = styled.img`
  width: 100%;
  height: auto;

  @media (max-width: 950px) {
    width: 183px;
  }
  @media (max-width: 465px) {
    width: 100%;
  }
`;

const SecureImage = styled.img`
  width: 158px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-top: 25px;

  @media (max-width: 950px) {
    width: 137px;
    margin-top: 0px;
  }
  @media (max-width: 465px) {
    width: 100%;
  }
`;

const SecurityImages = () => (
  <ImageDiv>
    <PaypalImage
      src="https://cdn.cardcash.com/website/secured-by-paypal.jpg"
      alt=""
    />
    <SecureImage
      src="https://cdn.cardcash.com/website/globalsign-seal.png"
      alt=""
    />
  </ImageDiv>
);

export default SecurityImages;
